import { gsap, ScrollTrigger } from "../global/gsap";

const initLondLife = (londonLifeEl) => {
    const lifeTitle = document.querySelector('.js-london-life-title');

    ScrollTrigger.create({
        trigger: lifeTitle,
        start: "bottom bottom",
        endTrigger: londonLifeEl,
        end: "bottom bottom",  
        pinSpacing: false, 
        onEnter: () => {
            gsap.set(lifeTitle, { position: "fixed", bottom: '-1px', top: "auto", left: 0 });
        },
        onLeave: () => {
            gsap.set(lifeTitle, { position: "absolute", bottom: '-1px', top: "auto" });
        },
        onEnterBack: () => {
            gsap.set(lifeTitle, { position: "fixed", bottom: '-1px', top: "auto", left: 0 });
        },
        onLeaveBack: () => {
            gsap.set(lifeTitle, { position: "absolute", top: 0, bottom: "auto", left: 0 });
        }
    });
   
    const createMediaHTML = (data) => {
        if (data.type === 'video') {
            return `<div class="student-life__grid-slot-content">
                <video autoplay muted loop playsinline poster="${data.poster}">
                    <source src="${data.src}" type="video/mp4">
                </video>
            </div>`;
        }
        return `<div class="student-life__grid-slot-content">
            <img src="${data.src}" srcset="${data.srcset}" alt="${data.alt}">
        </div>`;
    };

    const slots = londonLifeEl.querySelectorAll('.js-slot');
    const pool = (window.mediaPool || []).sort(() => 0.5 - Math.random());
    if (!pool.length) return;

    let activeMedia = [];

    const getNextMedia = (disallowedSrc) => {
        // Filter out everything currently active PLUS the one we just removed
        const available = pool.filter(item => 
            !activeMedia.includes(item.src) && item.src !== disallowedSrc
        );
        
        // Fallback: if pool is tiny, just pick anything except the disallowed one
        const selection = (available.length > 0) 
            ? available[Math.floor(Math.random() * available.length)] 
            : pool.find(item => item.src !== disallowedSrc) || pool[0];

        return selection;
    };

    // Swap the content of a specific slot
    const swapSlot = (slot) => {
        const oldContent = slot.querySelector('.student-life__grid-slot-content');
        let oldSrc = null;

        if (oldContent) {
            const mediaEl = oldContent.querySelector('img, video source');
            oldSrc = mediaEl?.getAttribute('src');
            activeMedia = activeMedia.filter(src => src !== oldSrc);
        }

        const data = getNextMedia(oldSrc);
        if (!data) return;

        activeMedia.push(data.src);

        const newContent = document.createElement('div');
        newContent.innerHTML = createMediaHTML(data);
        const newInner = newContent.firstElementChild;

        newInner.style.zIndex = 2;
        newInner.style.opacity = 0;

        slot.appendChild(newInner);

        const swapTl = gsap.timeline({
            onComplete: () => {
                if (oldContent) oldContent.remove();
                newInner.style.zIndex = 1;
            }
        });

        swapTl.to(newInner, { opacity: 1, duration: 1.5 });
        if (oldContent) swapTl.to(oldContent, { opacity: 0, duration: 1.5 }, "<");
    };

    const introTl = gsap.timeline();
    
    slots.forEach((slot, i) => {
        const data = pool[i % pool.length];
        activeMedia.push(data.src);
        
        slot.innerHTML = createMediaHTML(data);
    });

    const isDesktop = window.matchMedia('(pointer: fine)').matches;

    if (isDesktop) {
        slots.forEach((slot) => {
            let isSwapping = false;

            slot.addEventListener('mouseenter', () => {
                if (isSwapping) return;

                isSwapping = true;
                swapSlot(slot);

                // Lock the slot for the duration of the transition before allowing another swap
                gsap.delayedCall(1.5, () => { isSwapping = false; });
            });
        });
    } else {
        // Original timer-based swapping for mobile
        const startSwapping = () => {
            const visibleSlots = Array.from(slots).filter(slot => slot.offsetParent !== null);
            const slot = gsap.utils.random(visibleSlots);
            swapSlot(slot);
            gsap.delayedCall(1, startSwapping);
        };

        introTl.add(startSwapping, "+=0.5");
    }
};

export { initLondLife as default };